<template>
    <section role="banner">
        
        <div class="page-header-bg header-bg-cadastro hidden-xs" id="barra">
            <div class="container">
                <div style="display: block; margin-left: auto; margin-right: auto; width: 785px;">
                    <div class="col-md-12 col-lg-12 container-step" id="container-step">
                        <div class="col-md-1 step" :class="one" @click="emiteSalva('DadosPessoais')">
                            <div class="center-step" :class="one"></div>
                            <div class="text-step" :class="tOne" id="text-step1">Pessoal</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="two"></div>
                        <div class="col-md-1 step" :class="two" @click="emiteSalva('Endereco')">
                            <div class="center-step" :class="two"></div>
                            <div class="text-step" :class="tTwo" id="text-step2">Endereço</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="three"></div>
                        <div class="col-md-1 step" :class="three" @click="emiteSalva('Contatos')">
                            <div class="center-step" :class="three"></div>
                            <div class="text-step" :class="tThree" id="text-step3">Contatos</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="four"></div>
                        <div class="col-md-1 step" :class="four" @click="emiteSalva('Documentacao')">
                            <div class="center-step" :class="four"></div>
                            <div class="text-step" :class="tFour" id="text-step4">Documentos</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="five"></div>
                        <div class="col-md-1 step" :class="five" @click="emiteSalva('Filiacao')">
                            <div class="center-step" :class="five"></div>
                            <div class="text-step" :class="tFive" id="text-step4">Família</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="six"></div>
                        <div class="col-md-1 step" :class="six" @click="emiteSalva('Envio')">
                            <div class="center-step" :class="six"></div>
                            <div class="text-step" :class="tSix" id="text-step6">Envio</div>
                        </div>
                        <div class="col-md-1 inter-step" :class="seven"></div>
                        <div class="col-md-1 step step-end" :class="seven" id="bola" @click="emiteSalva('Fim')">
                            <div class="center-step center-step-end"></div>
                            <div class="thumbs-up-step" :class="tSeven"><i class="fa fa-thumbs-o-up"
                                    aria-hidden="false"></i> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-header-bg header-bg-cadastro header-bg-cadastro-sm-xs visible-xs">
            <div class="container container-xs">
                <div class="chevron-left" v-show="contentNumber != 1"
                    @click="emiteSalvaMobile('esquerda', contentNumber)">
                    <span>
                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="container-step container-step-sm-xs">
                    <div class="col-xs-1 step step-done">
                        <div class="center-step step-done">
                            <div class="text-number-xs">{{ contentNumber }}</div>
                        </div>
                    </div>
                    <div class="col-xs-11 text-done text-done-xs">{{ contentName }}</div>
                </div>
                <div class="chevron-right" v-show="contentNumber != 7"
                    @click="emiteSalvaMobile('direita', contentNumber)">
                    <span>
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
export default {
    name: 'barra-evolucao',

    props: {
        stepOne: { type: Number, required: false },
        stepTwo: { type: Number, required: false },
        stepThree: { type: Number, required: false },
        stepFour: { type: Number, required: false },
        stepFive: { type: Number, required: false },
        stepSix: { type: Number, required: false },
        stepSeven: { type: Number, required: false },
        textOne: { type: Number, required: false },
        textTwo: { type: Number, required: false },
        textThree: { type: Number, required: false },
        textFour: { type: Number, required: false },
        textFive: { type: Number, required: false },
        textSix: { type: Number, required: false },
        textSeven: { type: Number, required: false },
        contentName: { type: String, required: false },
        contentNumber: { type: Number, required: false }
    },
    computed: {
        one() { if (this.stepOne >= '1') return 'step-done' },
        two() { if (this.stepTwo >= '2') return 'step-done' },
        three() { if (this.stepThree >= '3') return 'step-done' },
        four() { if (this.stepFour >= '4') return 'step-done' },
        five() { if (this.stepFive >= '5') return 'step-done' },
        six() { if (this.stepSix >= '6') return 'step-done' },
        seven() { if (this.stepSeven >= '7') return 'step-done' },
        tOne() { if (this.textOne >= '1') return 'text-done' },
        tTwo() { if (this.textTwo >= '2') return 'text-done' },
        tThree() { if (this.textThree >= '3') return 'text-done' },
        tFour() { if (this.textFour >= '4') return 'text-done' },
        tFive() { if (this.textFive >= '5') return 'text-done' },
        tSix() { if (this.textSix >= '6') return 'text-done' },
        tSeven() { if (this.textSeven >= '7') return 'text-done' },
    },
    methods: {
        emiteSalva(nomeComponente) {
            if (nomeComponente == 'DadosPessoais') {
                const id = sessionStorage.getItem('userId'); // Recupera o ID da sessão
                if (id) {
                    this.$router.push({ name: nomeComponente, params: { id } });
                   // this.$eventBus.$emit('salvaAvanca', { id, nomeComponente });
                } else {
                    console.error('Nenhum ID encontrado na sessão');
                }
            } else {
                this.$router.push({ name: nomeComponente });
                //this.$eventBus.$emit('salvaAvanca', nomeComponente)
            }
        },
        emiteSalvaMobile(direcao, step) {
            console.log(`Direção: ${direcao}; Step: ${step}`)
            switch (step) {
                case 1:
                    this.emiteSalva('Endereco')
                    break;
                case 2:
                    direcao === 'esquerda' ? this.emiteSalva('DadosPessoais') : this.emiteSalva('Contatos')
                    break;
                case 3:
                    direcao === 'esquerda' ? this.emiteSalva('Endereco') : this.emiteSalva('Documentacao')
                    break;
                case 4:
                    direcao === 'esquerda' ? this.emiteSalva('Contatos') : this.emiteSalva('Filiacao')
                    break;
                case 5:
                    direcao === 'esquerda' ? this.emiteSalva('Documentacao') : this.emiteSalva('Envio')
                    break;
                case 6:
                    direcao === 'esquerda' ? this.emiteSalva('Filiacao') : this.emiteSalva('Fim')
                    break;
                case 7:
                    this.emiteSalva('Envio')
                    break;
                default:
                    break;
            }
        }
    },
    created() {
    },
    destroyed() {
    }
}
</script>

<style scoped>
.page-header-bg {
    overflow: hidden;
    position: relative;
    background: #ffffff;
    width: 100%;
}

.header-bg-cadastro-sm-xs {
    height: 53px;
    background-color: #00302e;
    margin-bottom: 15px;
}

.container-step {
    display: flex;
    align-items: center;
    height: 90px;
}

.container-step-sm-xs {
    padding-left: 15px;
    height: 53px;
    grid-column-start: 2;
}

.step {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background: #007863;
    position: relative;
    cursor: pointer;
}

.center-step {
    width: 18px;
    height: 18px;
    border-radius: 100%;
    background: #ffffff;
    padding-top: 15px;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translateX(50%) translateY(-50%);
}

.text-step {
    padding-top: 34px;
    margin-left: -15px;
    color: #007863;
    font-size: 1.3rem;
}

.step-end {
    width: 64px;
    height: 64px;
}

.center-step-end {
    width: 50px;
    height: 50px;
}

.thumbs-up-step {
    width: 50px;
    height: 50px;
    color: #007863;
    font-size: 35px;
    position: absolute;
    top: 50%;
    right: 36%;
    transform: translateX(50%) translateY(-50%);
}

.text-step-end {
    padding-top: 73px;
    margin-left: -8px;
}

.inter-step {
    width: 75px;
    height: 6px;
    background: #007863;
}

.step-done {
    background: #b8bf49;
}

.text-done {
    color: #b8bf49;
}

.text-done-xs {
    font-weight: 900;
    font-size: 18px;
}

.text-number-xs {
    font-weight: 900;
    font-size: 18px;
    color: #00302e;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translateX(50%) translateY(-50%);
}

.chevron-left,
.chevron-right {
    color: #b8bf49;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 53px;
    font-size: 18px;
}

.chevron-left {
    grid-column-start: 1;
}

.chevron-right {
    grid-column-start: 3;
}

.container-xs {
    display: grid;
    grid-template-columns: 13px 1fr 13px;
}

@media screen and (min-width: 992px) {
    .inter-step {
        width: 85px;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?7aba1dd9